// import { Send } from "lucide-react";
// import Swal from "sweetalert2";
// import { useState } from "react";

// const ContactForm = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     course: "",
//     message: "",
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     fetch("http://localhost/csg/save_contact.php", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(formData),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.success) {
//           Swal.fire({
//             icon: "success",
//             title: "Message Sent!",
//             text: "Thanks for contacting us. We'll get back to you soon.",
//           });
//           setFormData({
//             name: "",
//             email: "",
//             phone: "",
//             course: "",
//             message: "",
//           });
//         } else {
//           Swal.fire({
//             icon: "error",
//             title: "Error",
//             text:
//               data.message || "Something went wrong. Please try again later.",
//           });
//         }
//       })
//       .catch((err) => {
//         Swal.fire({
//           icon: "error",
//           title: "Error",
//           text: "Failed to connect to the server.",
//         });
//         console.error(err);
//       });
//   };

//   return (
//     <form onSubmit={handleSubmit} className="space-y-6">
//       {/* Name & Email */}
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//         <div>
//           <label className="block text-sm font-medium mb-1 text-black">
//             Full Name *
//           </label>
//           <input
//             type="text"
//             name="name"
//             value={formData.name}
//             onChange={handleChange}
//             className="w-full border border-gray-300 rounded px-3 py-2 text-black"
//             placeholder="Enter your full name"
//             required
//           />
//         </div>
//         <div>
//           <label className="block text-sm font-medium mb-1 text-black">
//             Email Address *
//           </label>
//           <input
//             type="email"
//             name="email"
//             value={formData.email}
//             onChange={handleChange}
//             className="w-full border border-gray-300 rounded px-3 py-2 text-black"
//             placeholder="Enter your email"
//             required
//           />
//         </div>
//       </div>

//       {/* Phone & Course */}
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//         <div>
//           <label className="block text-sm font-medium mb-1 text-black">
//             Phone Number *
//           </label>
//           <input
//             type="tel"
//             name="phone"
//             value={formData.phone}
//             onChange={handleChange}
//             className="w-full border border-gray-300 rounded px-3 py-2 text-black"
//             placeholder="Enter your phone number"
//             pattern="[0-9]{10,15}"
//             required
//           />
//         </div>
//         <div>
//           <label className="block text-sm font-medium mb-1 text-black">
//             Course of Interest *
//           </label>
//           <input
//             type="text"
//             name="course"
//             value={formData.course}
//             onChange={handleChange}
//             className="w-full border border-gray-300 rounded px-3 py-2 text-black"
//             placeholder="Enter course name"
//             required
//           />
//         </div>
//       </div>

//       {/* Message */}
//       <div>
//         <label className="block text-sm font-medium mb-1 text-black">
//           Message *
//         </label>
//         <textarea
//           name="message"
//           value={formData.message}
//           onChange={handleChange}
//           className="w-full border border-gray-300 rounded px-3 py-2 text-black"
//           rows="5"
//           placeholder="Tell us about your learning goals, timings, or questions..."
//           required
//         ></textarea>
//       </div>

//       {/* Submit */}
//       <button
//         type="submit"
//         className="w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 flex items-center justify-center"
//       >
//         <Send className="h-4 w-4 mr-2" /> Send Message
//       </button>
//     </form>
//   );
// };

// export default ContactForm;

import { Send } from "lucide-react";
import Swal from "sweetalert2";
import confetti from "canvas-confetti"; // 🎉 import here
import { useState } from "react";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    course: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch("https://csgedu.in/csg/save_contact.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          // 🌟 Trigger star/confetti rain
          startConfetti();

          Swal.fire({
            icon: "success",
            title: "Message Sent!",
            text: "Thanks for contacting us. We'll get back to you soon.",
          });

          setFormData({
            name: "",
            email: "",
            phone: "",
            course: "",
            message: "",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text:
              data.message || "Something went wrong. Please try again later.",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to connect to the server.",
        });
        console.error(err);
      });
  };

  // 🎇 Star Mazhai (Confetti Effect)
  const startConfetti = () => {
    const duration = 2 * 1000; // 2 seconds
    const animationEnd = Date.now() + duration;

    const interval = setInterval(() => {
      if (Date.now() > animationEnd) return clearInterval(interval);

      confetti({
        particleCount: 20,
        spread: 100,
        startVelocity: 30,
        gravity: 0.8,
        scalar: 1.2,
        origin: {
          x: Math.random(),
          y: Math.random() - 0.2,
        },
        colors: ["#FFD700", "#FF69B4", "#87CEEB", "#00FF7F"],
      });
    }, 200);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Name & Email */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1 text-black">
            Full Name *
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2 text-black"
            placeholder="Enter your full name"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1 text-black">
            Email Address *
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2 text-black"
            placeholder="Enter your email"
            required
          />
        </div>
      </div>

      {/* Phone & Course */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1 text-black">
            Phone Number *
          </label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2 text-black"
            placeholder="Enter your phone number"
            pattern="[0-9]{10,15}"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1 text-black">
            Course of Interest *
          </label>
          <input
            type="text"
            name="course"
            value={formData.course}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2 text-black"
            placeholder="Enter course name"
            required
          />
        </div>
      </div>

      {/* Message */}
      <div>
        <label className="block text-sm font-medium mb-1 text-black">
          Message *
        </label>
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded px-3 py-2 text-black"
          rows="5"
          placeholder="Tell us about your learning goals, timings, or questions..."
          required
        ></textarea>
      </div>

      {/* Submit */}
      <button
        type="submit"
        className="w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 flex items-center justify-center"
      >
        <Send className="h-4 w-4 mr-2" /> Send Message
      </button>
    </form>
  );
};

export default ContactForm;
